"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _tooltip = require("../tooltip");
var _icon = require("../icon");
var _configProvider = require("../config-provider/configProvider");
var _typeof = require("../utils/data/typeof");
var _excluded = ["title", "content", "size", "closeable", "children", "maxHeight"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof2(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Popover = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var title = props.title,
    content = props.content,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    _props$closeable = props.closeable,
    closeable = _props$closeable === void 0 ? false : _props$closeable,
    children = props.children,
    maxHeight = props.maxHeight,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('popover');
  var tooltipRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      forceAlign: function forceAlign() {
        var _tooltipRef$current;
        (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 || _tooltipRef$current.forceAlign();
      }
    };
  });
  var closePopover = function closePopover() {
    var _tooltipRef$current2;
    (_tooltipRef$current2 = tooltipRef.current) === null || _tooltipRef$current2 === void 0 || _tooltipRef$current2.setPopLayerVisible(false);
  };
  var renderContent = function renderContent(maxH) {
    var result = [];
    if (title) {
      result.push( /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-inner-title-container"),
        key: "title"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-inner-title")
      }, (0, _typeof.isFunction)(title) ? title() : title), closeable ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        type: "close",
        onClick: closePopover,
        className: "".concat(prefixCls, "-close-icon")
      }) : null));
    }
    if (content) {
      result.push( /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-inner-content-container"),
        key: "content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-inner-content"),
        key: "content"
      }, (0, _typeof.isFunction)(content) ? content() : content), !title && closeable ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        type: "close",
        onClick: closePopover,
        className: "".concat(prefixCls, "-close-icon")
      }) : null));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        maxHeight: maxH,
        overflow: 'auto'
      },
      className: size === 'small' ? "".concat(prefixCls, "-sm") : ''
    }, result);
  };
  return /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, _objectSpread(_objectSpread({}, restProps), {}, {
    ref: tooltipRef,
    color: "light",
    prefixCls: prefixCls,
    message: renderContent(maxHeight)
  }), children);
});
Popover.displayName = 'Popover';
var _default = exports.default = Popover;